import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable({
  providedIn: 'root'
})
export class ShipmentService {
  public url: any;
  public token: any;

  private pendingBulkItems: Array<any> | null = null;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  setPendingBulkItems(items: Array<any>): void {
    this.pendingBulkItems = items;
  }

  consumePendingBulkItems(): Array<any> {
    const items = this.pendingBulkItems ?? [];
    this.pendingBulkItems = null;
    return items;
  }

  private createHeaders(token: any): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': token
    });
  }

  private createParams(data: any, token:any = ''): any {
    const json = encodeURIComponent(JSON.stringify(data));
    return `json=${json}&authorization=${token}`;
  }

  create(token: any, data: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/newshipmentfromso/${id}`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  addFreight(token: any, data: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/addfreight/${id}`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }


  savePackages(token: any, data: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/savepackages/${id}`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  saveCreatedPackages(token: any, data: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/savecreatedpackages/${id}`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  createNewPackages(token: any, data: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/createnewpackages/${id}`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }


  removePackages(token: any, data: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/removepackages`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  

  editvalue(token: any, data: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/editvalue/${id}`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }



  markAsCompleted(token: any, shipment_id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/markascompleted/${shipment_id}`, this.createParams(null,token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }
 

  voidShipment(token: any, shipment_id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/dovoid/${shipment_id}`, this.createParams(null,token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  createfromzero(token: any, data: any): Observable<any> {

    return this._http.post<any>(`${this.url}/shipment/newshipment`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

edit(token: any, id, data: any): Observable<any> {

    return this._http.post<any>(`${this.url}/shipment/edit/${id}`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  addItemsToShipment(token: any,id: any, data: any): Observable<any> {

    return this._http.post<any>(`${this.url}/shipment/additemstoshipment/${id}`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  detail(token: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/detail/${id}`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  availableItemsToShip(token: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/availableitemstoship/${id}`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  track(token: any, data: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/trackshipment`, this.createParams(data), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  updateCarriersSelection(token: string, selectedCarriers: any) {
    const headers = new HttpHeaders().set('authorization', token);
    return this._http.post<any>(`${this.url}/shipment/update-carriers-selection`,this.createParams(selectedCarriers,token), { headers: this.createHeaders(token) });
  }

  returnItems(token: any, data: any): Observable<any> {
     return this._http.post<any>(`${this.url}/shipment/returnitems`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }


  returnBySO(token: any, soid: any): Observable<any> {
     return this._http.post<any>(`${this.url}/return/listbyso/${soid}`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }
  listshipmentitems(
    token: any,
    shipmentId: any,
    scope: string = 'prepare',
    page: any = 1,
    perpage: any = 10,
    filtros: any[] = [],
    sort: string = '',
    order: string = ''
  ): Observable<any> {

    let url = `${this.url}/shipment/listitems/${shipmentId}?page=${page}&perpage=${perpage}&scope=${encodeURIComponent(scope)}`;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + '&' + filtro.key + '=' + encodeURIComponent(filtro.value);
        if (filtro.type) {
          url = url + '&' + filtro.key_type + '=' + filtro.type;
        }
      }
    }

    if (sort) {
      url = url + '&sort=' + encodeURIComponent(sort) + '&order=' + encodeURIComponent(order || 'ASC');
    }

    return this._http.post<any>(`${url}`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }
  returnBySOList(
    token: any,
    soid: any,
    data: any = {},
    page: number = 1,
    perpage: any = 10,
    filtros: any[] = []
  ): Observable<any> {
  
    let url = `/return/returnslist/${soid}?page=${page}&perpage=${perpage}`;
  
    // Append column filters como query params
    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }
  
    // data lleva sort y order en el body
    return this._http.post<any>(
      `${this.url}${url}`,
      this.createParams(data, token),
      { headers: this.createHeaders(token) }
    ).pipe(map(res => res));
  }
  

  returnById(token: any, soid: any,page: any, itemsPorPaginaN: string): Observable<any> {
     return this._http.post<any>(`${this.url}/return/detail/${soid}?page=${page}&perpage=${itemsPorPaginaN}`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }



  listshipmentsbystatus(
    token: any, 
    page: any = 1,
    perPage: any,
    filtros: any, data: any): Observable<any> {

    let url = `${this.url}/shipment/listbystatus?page=${page}&perpage=${perPage}`;

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url += `&${filtro.key}=${filtro.value}`;
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    return this._http.post<any>(`${url}`,  this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }
  listshipmentstoship(
    token: any, 
    page: any = 1,
    perPage: any,
    filtros: any, data: any): Observable<any> {

    let url = `${this.url}/shipment/listbystatusClient?page=${page}&perpage=${perPage}`;

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url += `&${filtro.key}=${filtro.value}`;
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    return this._http.post<any>(`${url}`,  this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }
  listshipmentstoprocessed(
    token: any, 
    page: any = 1,
    perPage: any,
    filtros: any, data: any): Observable<any> {

    let url = `${this.url}/shipment/listbystatusProcessed?page=${page}&perpage=${perPage}`;

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url += `&${filtro.key}=${filtro.value}`;
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    return this._http.post<any>(`${url}`,  this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }
  listshipmentstoall(
    token: any, 
    page: any = 1,
    perPage: any,
    filtros: any, data: any): Observable<any> {

    let url = `${this.url}/shipment/listbystatusAll?page=${page}&perpage=${perPage}`;

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url += `&${filtro.key}=${filtro.value}`;
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    return this._http.post<any>(`${url}`,  this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }
  
  
  listcarriers(token: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/listcarriers?page=1`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  listExternalCarriers(token: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/external-carriers?page=1`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  importCarriers(token: string, carriers: any[]) {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });;
     const params = {
      json: JSON.stringify(carriers),
      authorization: token,
    };

    return this._http.post<any>
    (
      `${this.url}/shipment/shipengine-import-carriers`, 
      this.buildSearchParams(params), 
      { headers }
    );
  }

  listbypo(token: any, data: any, filter = null): Observable<any> {

    const queryString = new URLSearchParams(filter).toString();

  // Si hay filtros, los añadimos a la URL
  const url = queryString
    ? `${this.url}/shipment/listbyso/${data}?${queryString}`
    : `${this.url}/shipment/listbyso/${data}`;


    return this._http.post<any>(`${url}`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }
  listshipforso(token: any, data: any, filter = null,filtros,json): Observable<any> {

    const queryString = new URLSearchParams(filter).toString();

  // Si hay filtros, los añadimos a la URL
  let url = queryString
    ? `${this.url}/shipment/listall/${data}?${queryString}`
    : `${this.url}/shipment/listall/${data}`;

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url += `&${filtro.key}=${filtro.value}`;
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    return this._http.post<any>(`${url}`, this.createParams(json, token),  { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  
  listbypov1(
    token: any,
    data: any,
    filter: any = null,
    page: any = 1,
    perpage: any = 10,
    filtros: any[] = [],
    sort: string = '',
    order: string = ''
  ): Observable<any> {
  
    let url = `${this.url}/shipment/listall/${data}?page=${page}&perpage=${perpage}`;
  
    if (filter) {
      Object.keys(filter).forEach(k => {
        const v = filter[k];
        if (v !== null && v !== undefined && `${v}` !== '') {
          url = url + '&' + k + '=' + encodeURIComponent(v);
        }
      });
    }
  
    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + '&' + filtro.key + '=' + encodeURIComponent(filtro.value);
        if (filtro.type) {
          url = url + '&' + filtro.key_type + '=' + filtro.type;
        }
      }
    }
  
    if (sort) {
      url = url + '&sort=' + encodeURIComponent(sort) + '&order=' + encodeURIComponent(order || 'ASC');
    }
  
    return this._http.post<any>(`${url}`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  soList(token: any): Observable<any> {
    return this._http.post<any>(`${this.url}/soinfo/listlite`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  additemstopackage(token: any, data: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/additemstopackage/${id}`, this.createParams(data), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }


  setTrackingNumberToPkg(token: any, data: any, id: any): Observable<any> {

    return this._http.post<any>(`${this.url}/shipment/settrackingnumbertopkg/${id}`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  setMultipleShipping(token: any, id: any, enabled: boolean): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/setmultipleshipping/${id}`, this.createParams({ enabled }, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  removeitems(token: any, data: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/removeitems/${id}`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  domassivevoid(token: any, data: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/domassivevoid`, this.createParams(data, token), { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  getRates(token: string, body: any) {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token
    };
    return this._http.post<any>(`${this.url}/shipment/shipengine/rates`, body, { headers });
  }

  shipengineGetPackagesFromCarrier(token: string, body: any) {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token
    };
    return this._http.post<any>(`${this.url}/shipment/shipengine-get-packages-from-carrier`, body, { headers });
  }

  generateLabel(token: string, body: any) {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token
    };
    return this._http.post<any>(`${this.url}/shipment/shipengine_create_label`, body, { headers });
  }

  generateLabelDirectly(token: string, body: any) {
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': token
    };
    return this._http.post<any>(`${this.url}/shipment/shipenginecreatelabeldirectly`, body, { headers });
  }


  mailToCustomer(token: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/sendlabelbyemail/${id}`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }


  getshipmentspackages(token: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/getshipmentspackages/${id}`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  getitemsinpackage(token: any, id: any): Observable<any> {
    return this._http.post<any>(`${this.url}/shipment/getitemspackage/${id}`, `authorization=${token}`, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  getScheduled(token: any, page = 1, perPage = 10, busqueda = '', voided = 0): Observable<any> {
    const json = encodeURIComponent(JSON.stringify({ busqueda }));
    const params = busqueda === '' ? `authorization=${token}` : `json=${json}&authorization=${token}`;
    return this._http.post<any>(`${this.url}/shipment/list?page=${page}&perpage=${perPage}&voided=${voided}`, params, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  getPendingSO(token: any, page = 1, perPage = 10, busqueda = ''): Observable<any> {
    const json = encodeURIComponent(JSON.stringify({ busqueda }));
    const params = busqueda === '' ? `authorization=${token}` : `json=${json}&authorization=${token}`;
    return this._http.post<any>(`${this.url}/soinfo/listbyshipstatus/PENDING?page=${page}&perpage=${perPage}`, params, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  getPendingPO(token: any, page = 1, perPage = 10, busqueda = ''): Observable<any> {
    const json = encodeURIComponent(JSON.stringify({ busqueda }));
    const params = busqueda === '' ? `authorization=${token}` : `json=${json}&authorization=${token}`;
    return this._http.post<any>(`${this.url}/poinfo/listbyshipstatus/PENDING?page=${page}&perpage=${perPage}`, params, { headers: this.createHeaders(token) })
      .pipe(map(res => res));
  }

  private buildSearchParams(params: any): any {
    return Object.keys(params)
      .map((key) => `${key}=${encodeURIComponent(params[key])}`)
      .join("&");
  }

}
